import { Card, CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout'
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import React from 'react'
import { PartialSpinny } from './Common/Spinny';
import { ChatApi } from '../redux/api/ChatApi';
import { SetVisibility } from '../redux/reducers/ChatSlice';
import { useReduxDispatch } from '../redux/hooks';

export default function UserOffline() {
    const dispatch = useReduxDispatch();
    const { data: myVisibility } = ChatApi.useGetMyVisibilityQuery();
    const [updateVisibility, { isLoading }] = ChatApi.useUpdateUserVisibilityMutation();
    const items = [
        { text: "Internal / External", id: 2, img: '/images/chat_all.jpg' },
        { text: "Internal", id: 1, img: '/images/chat_internal.jpg' },
    ]

    const itemRender = (li, itemProps) => {
        const index = itemProps.index;
        //console.log('li.props', li.props, itemProps);
        const itemChildren = (
            <span className="k-hbox">
                <img src={itemProps.dataItem.img} alt={itemProps.dataItem.text} />

                <span className='ml-1'>{itemProps.dataItem.text}</span>
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    const changeVisibility = (e: DropDownListChangeEvent) => {
        updateVisibility({ ID: 0, Contact_Id: myVisibility.Contact_Id, Visibility: e.target.value.id }).unwrap()
            .then(() => {
                //reconnect to signalR
                dispatch(SetVisibility(e.target.value.id));
            });
    }

    return (
        <div className='chat-user-offline'>
            <Card>
                <CardHeader className="k-hbox">
                    <img src='/images/chat_off.jpg' width={'34px'} height={'30px'} />
                    <CardTitle>
                        You are currently offline</CardTitle>
                </CardHeader>
                <CardBody>
                    Select your visibility status to go online:
                    <DropDownList
                        textField="text"
                        dataItemKey='id'
                        data={items}
                        itemRender={itemRender}
                        defaultItem={{ text: "Select ..." }}
                        style={{
                            width: "200px",
                        }}
                        onChange={changeVisibility}
                    />
                </CardBody>

                {isLoading && <PartialSpinny />}

            </Card>
        </div>
    )
}
